import Button from '@doordash/component-button'
import { NumberField } from '@doordash/component-fields'
import { Text, Stack, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import t from './strings'
import { PaddedLabel, SpreadStack } from './styles'

const GST_INFO =
  'https://www.abr.gov.au/business-super-funds-charities/applying-abn'

type Props = {
  label: string
  doSubmit?: (
    uniqueLink: string,
    australianBusinessNumber: number
  ) => Promise<any>
  onChange: (any) => void
  error?: string
  value?: string
}

type State = {
  australianBusinessNumber: number
}

export class AustralianBusinessNumber extends React.Component<Props, State> {
  public static state = { australianBusinessNumber: '' }

  public render() {
    const { label, error, value } = this.props

    return (
      <div>
        <SpreadStack size={Stack.Sizes.XxxxSmall}>
          <Text tag="label" styles={Text.Styles.Medium14}>
            {label}
          </Text>
          <Text
            color={Text.Colors.TextTertiary}
            size={Text.Sizes.S12}
            weight={Text.Weights.Bold}
          >
            {t.required()}
          </Text>
        </SpreadStack>
        <StackChildren size={StackChildren.Sizes.XxxSmall}>
          <PaddedLabel color={Text.Colors.TextTertiary}>
            {t.abnLabel()} (
            <Button
              tag="a"
              href={GST_INFO}
              type={Button.Types.FlatPrimary}
              isInline={true}
              padding={Button.Padding.None}
              target="_blank"
            >
              {t.abnExplanation()}
            </Button>
            )
          </PaddedLabel>

          <NumberField
            id="abn"
            max={99999999999}
            value={value}
            placeholder="12 345 678 901"
            onChange={australianBusinessNumber =>
              this.handleAbnChange(australianBusinessNumber)
            }
            error={error}
            autoComplete="off"
          />
        </StackChildren>
      </div>
    )
  }

  private handleAbnChange = value => {
    const { onChange } = this.props
    if (onChange) {
      onChange(value)
    }
  }
}

export default AustralianBusinessNumber
